"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = require("react");
var _invariant = _interopRequireDefault(require("invariant"));
var _withAuth = _interopRequireDefault(require("./withAuth"));
var AuthRefresh = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2.default)(AuthRefresh, _Component);
  function AuthRefresh() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.timer = void 0;
    _this.renewToken = function () {
      var client = _this.props.auth.client;
      (0, _invariant.default)(client, "AuthClient missing in context. " + "Did you forget to wrap your app in AuthProvider?");
      client.renewToken(function (err, result) {
        if (err) {
          if (_this.props.onError != null) {
            _this.props.onError(err);
          }
        } else if (_this.props.onSuccess != null) {
          _this.props.onSuccess(result);
        }
      });
    };
    return _this;
  }
  var _proto = AuthRefresh.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.checkSession();
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this$props$auth$sess = this.props.auth.session,
      accessToken = _this$props$auth$sess.accessToken,
      expiresAt = _this$props$auth$sess.expiresAt,
      idToken = _this$props$auth$sess.idToken,
      refreshToken = _this$props$auth$sess.refreshToken,
      provider = _this$props$auth$sess.provider;
    var _prevProps$auth$sessi = prevProps.auth.session,
      oldAccessToken = _prevProps$auth$sessi.accessToken,
      oldExpiresAt = _prevProps$auth$sessi.expiresAt,
      oldIdToken = _prevProps$auth$sessi.idToken,
      oldRefreshToken = _prevProps$auth$sessi.refreshToken,
      oldProvider = _prevProps$auth$sessi.provider;
    if (accessToken === oldAccessToken && expiresAt === oldExpiresAt && idToken === oldIdToken && refreshToken === oldRefreshToken && provider === oldProvider) {
      return;
    }
    if (this.timer != null) {
      clearTimeout(this.timer);
    }
    if (this.props.auth.session != null) {
      this.checkSession();
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.timer != null) {
      clearTimeout(this.timer);
    }
  };
  _proto.checkSession = function checkSession() {
    var _this$props = this.props,
      offset = _this$props.offset,
      auth = _this$props.auth;
    var session = auth.session;
    if (session != null && session.expiresAt != null) {
      var expiresAt = session.expiresAt - offset;
      var now = Date.now();
      if (now < expiresAt) {
        this.timer = setTimeout(this.renewToken, expiresAt - now);
      } else {
        this.renewToken();
      }
    }
  };
  _proto.render = function render() {
    return null;
  };
  return AuthRefresh;
}(_react.Component);
AuthRefresh.defaultProps = {
  offset: 10000,
  onSuccess: undefined,
  onError: undefined
};
var _default = exports.default = (0, _withAuth.default)(AuthRefresh);